import { createIcon } from '@chakra-ui/react'

export const StakeIcon = createIcon({
  displayName: 'StakeIcon',
  path: (
    <>
      <path
        d='M10.8376 17.1668H9.17096V7.1668L4.58763 11.7501L3.4043 10.5668L10.0043 3.9668L16.6043 10.5668L15.421 11.7501L10.8376 7.1668V17.1668Z'
        fill='currentColor'
      />
    </>
  ),
  viewBox: '0 0 21 21',
})
